import React, { useEffect, useState } from "react";
import "./css.css";
import { useNavigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';
import { Button } from "react-bootstrap";
import { db } from "../config_firebase";
import {
  collection,
  addDoc,
  getDocs,
  doc,
} from "firebase/firestore";

/**
 * @author
 * @function Login
 *
 **/

 export const Consent = (props) => {
    // const [pic, setPic] = useState(img1);
    const history = useNavigate();
    const [url, setUrl] = useState(window.location.href);
    const [userId, setUserId] = useState("");
    const [ifConfirm, setifConfirm] = useState(false)

    useEffect(() => {
        const iosa = url.split(",");
        setUserId(iosa[1]);
      }, []);

    async function addclick(data) {
      const docRef = await addDoc(collection(db, "clicksdata"), {
        data,
      });
    }

    const next = () => {
      if(ifConfirm === true){
        const consent_button = {
          time: Date.now(),
          userId: userId,
          buttonType: "consent_button",
        };
        addclick(consent_button);
        console.log("g", userId);
        history(`/instructions/?,${userId}`);
      }
    };    
    
    const ifConf = () => {
      setifConfirm(!ifConfirm)
      console.log(ifConfirm)
    }
    return(
        <div className="main">
            <div className="content">
                <h1>Informed Consent to Participate in Study</h1>
                <p> <br></br> 1. You are about to participate in a decision-making study.  
                    <br></br> 2. The study takes about 10-15 minutes.
                    <br></br> 3. In the study you will make a number of predictions and decisions.
                    <br></br> 4. The anonymity of your responses is guaranteed, so you can answer as openly
                    <br></br> and honestly as possible. We do not collect any identifying details.
                    <br></br> The study has been approved by the BGU Ethical Review Board.
                    <br></br> 5. If you have any questions about the study, feel free to email: meytale@post.bgu.ac.il.
                    <br></br> 6. If you agree to participate in the study, please click the button below. 
                    <br></br> If you do not wish to participate you may close the page.
                </p>
            </div>
            <div className="agreementbox">
              <Form>
                <Form.Check 
                  type="switch"
                  id="custom-switch"
                  label="I hereby confirm that I have understood the above and freely give my consent to participate in this study."
                  onClick={ifConf}
                />
              </Form>
            </div>
            <div>
                <br></br>
                {ifConfirm ? <Button variant="outline-light" className="consentnextbutton" onClick={next}>Next</Button> : null}
            </div>
        </div>
    );
};